import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { NoDataComponent } from 'ngx-lib';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NoDataComponent]
})
export class NotFoundComponent {
    constructor(private readonly router: Router) {}

    onLinkActionClicked() {
        this.router.navigate(['/dashboard']);
    }
}
